import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
//import { saveAuction, getAuctions, saveTradeSession } from '../../Api';
import Moment from 'react-moment';//Both are required here
import moment from 'moment'; //Both are required here
import useApi from '../../api/useApi'
import { de } from 'date-fns/esm/locale';

const Auctions = () => {
    const navigate = useNavigate();
    const [auctions, setAuctions] = useState([]);
    const [auctioneers, setAuctioneers] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalSessionVisible, setSessionModalVisible] = useState(false);
    const [auctioneerId, setAuctioneerId] = useState(0);
    const [auctionId, setAuctionId] = useState(0);
    const [auctionNo, setAuctionNo] = useState(0);
    const [auctionCenter, setAuctionCenter] = useState(1);
    const [auctionDate, setAuctionDate] = useState(new Date());
    const [sessionStartTime, setSessionStartTime] = useState(null);
    const [sessionEndTime, setSessionEndTime] = useState(null);
    const [isStartTimeDisabled, setIsStartTimeDisabled] = useState(true);
    const [minDate, setMinDate] = useState(moment().toDate())
    const [minTime, setMinTime] = useState(moment())
    const [maxTime, setMaxTime] = useState(moment().endOf('day'))
    const [poolingStartTime, setPoolingStartTime] = useState(null);
    const [poolingEndTime, setPoolingEndTime] = useState(null);
    const api = useApi();
    const filterPassedTime = (time) => {
        const currentDate = new Date();
        const selectedDate = new Date(time);

        return currentDate.getTime() < selectedDate.getTime();
    };

    const setEndTime = (time) => {
        const currentDate = new Date();
        const selectedDate = new Date(time);
        if (selectedDate.getTime()  > currentDate.getTime() ) {
            if (selectedDate.getTime() > new Date(sessionStartTime).getTime())
                setSessionEndTime(time);
            else
                alert("Session end time cannot be less then session start time.");
        }
    }

    const setStartTime = (time) => {
        const currentDate = new Date();
        const selectedDate = new Date(time);
        if (selectedDate.getTime() > currentDate.getTime()) {
            setSessionStartTime(time);
        }
    }

    const setPoolingStart = (time) => {
        const selectedDate = new Date(time);
        if (selectedDate.getTime() < new Date(auctionDate).getTime()) {
            setPoolingStartTime(time);
        } else {
            alert("Pooling start time cannot be on or after the auction date.");
        }
    }

    const setPoolingEnd = (time) => {
        const selectedDate = new Date(time);
        if (selectedDate.getTime() < new Date(auctionDate).getTime()) {
            setPoolingEndTime(time);
        } else {
            alert("Pooling end time cannot be on or after the auction date.");
        }
    }


    const loadAuctions = async () => {
        try {
            const auctionsList = await api.getAuctions();
            setAuctions(auctionsList);
        } catch (error) {
            alert('Unable to fetch Auction data.');
        }

    }

    const loadAuctioneers = async () => {
        try {
            const _auctioners = await api.getAuctioneersDropdown();
            setAuctioneers(_auctioners);
        } catch (error) {
            alert('Unable to fetch auctioneers data.');
        }
    }

    useEffect(() => {
        loadAuctions();
    }, []);

    const createNewAuction = () => {
        loadAuctioneers();
        setAuctioneerId(null);
        setAuctionId(0);
        setAuctionNo(null);
        setAuctionDate(null);
        setPoolingStartTime(null);
        setPoolingEndTime(null);
        setMinDate(new Date())
        setModalVisible(true);
    }

    const editAuction = (auc) => {
        loadAuctioneers();

        setTimeout(() => {
            setAuctioneerId(auc.auctioneerId);
            setAuctionId(auc.auctionId);
            setAuctionNo(auc.auctionNo);
            setAuctionDate(new Date(auc.auctionDate));
            setAuctionCenter(auc.auctionCenter);
            setPoolingStartTime(new Date(auc.poolingStartTime));
            setPoolingEndTime(new Date(auc.poolingEndTime));

            //setMinDate(new Date(auc.auctionDate))
        }, 200)
        setModalVisible(true);
    }

    const handleModalVisibility = () => {
        setModalVisible(!modalVisible);
        if (!modalVisible)
            loadAuctioneers();
    };

    const handleClose = () => {
        setModalVisible(false);
    };

    const createNewSession = (auctionId) => {
        setAuctionId(auctionId);
        setSessionStartTime(null)
        setSessionEndTime(null)
        setIsStartTimeDisabled(false);
        setSessionModalVisible(!modalSessionVisible);
    }

    const updateSession = (auctionId, startTime, endTime) => {
        setAuctionId(auctionId);
        if (startTime)
            setSessionStartTime(new Date(startTime));
        if (endTime)
            setSessionEndTime(new Date(endTime));

        setIsStartTimeDisabled(true);
        setSessionModalVisible(!modalSessionVisible);

    };

    const deleteSession = async (auctionId) => {
        if (window.confirm('Are you sure you want to delete this session?') === true) {
            try {
                const result = await api.deleteAuctionSession(auctionId);
                alert(result);
                loadAuctions();
            } catch (error) {
                console.log(error);
                alert('Unable to delete lot detail.');
            }
        }
    }

    const handleSessionModalVisibility = () => {
        setSessionModalVisible(!modalSessionVisible);
    };

    const handleAuctioneerChange = (event) => {
        setAuctioneerId(event.target.value);
    };

    const handleAuctionNoChange = (event) => {
        setAuctionNo(event.target.value);
    };

    const handleDateChange = (_auctionDate) => {
        setAuctionDate(_auctionDate);

        // Create a moment object from the auction date
        const auctionDateMoment = moment(_auctionDate);

        // Set pooling start time to 2 days before the auction date
        const poolingStart = auctionDateMoment.clone().subtract(2, 'days').toDate();
        setPoolingStartTime(poolingStart);

        // Set pooling end time to just before midnight of the auction date
        const poolingEnd = auctionDateMoment.clone().subtract(1, 'seconds').toDate();
        setPoolingEndTime(poolingEnd);

    };

    const handleCenterChange = (event) => {
        setAuctionCenter(event.target.value);
    };

    const deleteAuction = async (auctionId) => {
        if (window.confirm("Are you sure you want to delete this Auction?") === true) {
            try {
                const result = await api.deleteAuction(auctionId);
                alert(result);
                loadAuctions();
            } catch (error) {
                console.log(error);
                alert('Unable to delete auction.');
            }
        }
    }

    const closeAuction = async (auctionId) => {
        if (window.confirm("Are you sure you want to close this Auction?") === true) {
            try {
                await api.closeAuction(auctionId)
                    .then((response) => {
                        if (response.success) {
                            alert("Auction closed successfully");
                            loadAuctions();
                        }
                        else
                            alert(response.message);
                    })
                    .catch((error) => {
                        console.error('Error closing auction :', error);
                    });
               
            } catch (error) {
                console.log(error);
                alert('Unable to close auction.');
            }
        }
    }

    const viewLotDetails = (e, auction) => {
        e.preventDefault();
        navigate(`/lotDetails/${auction.auctionId}`, { state: { auctioneer: auction.auctioneer, auctionNo: auction.auctionNo, auctionDate: auction.auctionDate } });
    };

    const handleLotGridView = (_auctionId) => {
        navigate(`/lotGridView/${_auctionId}`);
    }

    const onSaveAuction = async () => {

        const params = {
            auctionId: auctionId,
            auctioneerId: auctioneerId,
            auctionNo: auctionNo,
            auctionDate: auctionDate,
            auctionCenter: auctionCenter,
            poolingStartTime: poolingStartTime,
            poolingEndTime: poolingEndTime,

        };

        await api.saveAuction(params).then((response) => {
            if (response.success) {
                api.getAuctions().then((data2) => {
                    setAuctions(data2);
                })
                setModalVisible(false);
                alert(response.message);
            }
            else
                alert(response.message);

        }).catch((error) => {
            alert('Error saving auction:', error)
        });
    };

    const onSaveTradeSession = async () => {
        const params = {
            auctionId,
            sessionStartTime: new Date(sessionStartTime).toISOString(),
            sessionEndTime: new Date(sessionEndTime).toISOString(),
        };
        await api.saveTradeSession(params).then((response) => {
            if (response.success) {
                api.getAuctions().then((data) => {
                    setAuctions(data);
                })
                setSessionModalVisible(false);
                alert(response.message);
            }
            else
                alert(response.message);

        }).catch((error) => {
            console.error('Error saving auction:', error);
        });
    };


    return (
        <div>
            <div className="inner-body">
                <div className="page-header">
                    <div>
                        <h2 className="main-content-title tx-24 mg-b-5">Auctions</h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a className="custom-link" onClick={() => navigate('/home')}>Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Auctions</li>
                        </ol>
                    </div>
                    <div className="d-flex">
                        <div className="justify-content-center">
                            {/*<button type="button" className="btn btn-white btn-icon-text my-2 me-2" >*/}
                            {/*    <i className="fe fe-download me-2"></i> Import*/}
                            {/*</button>*/}
                            {/*<button type="button" className="btn btn-white btn-icon-text my-2 me-2">*/}
                            {/*    <i className="fe fe-filter me-2"></i> Filter*/}
                            {/*</button>*/}
                            <button type="button" className="btn btn-primary my-2 btn-icon-text" onClick={createNewAuction}>
                                <i className="fe fe-edit me-2"></i> Create New Auction
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card">
                            {/*<div className="card-header border-bottom-0 pb-0">*/}
                            {/*    <h6 class="main-content-label mb-1">Basic DataTable</h6>*/}
                            {/*    <p class="text-muted card-sub-title">Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</p>*/}
                            {/*</div>*/}
                            <div className="card-body">
                                <div className="table-responsive border border-bottom-0 ">
                                    <table className="table table-hover table-striped  table-vcenter   mb-0">
                                        <thead>
                                            <tr>
                                                <th className="wd-lg-4p text-center"><span>#</span></th>
                                                <th className="wd-lg-20p text-center text-nowrap"><span>Auction Id</span></th>
                                                <th className="min-w-240"><span>Auctioneer</span></th>
                                                <th className="wd-lg-20p text-center"><span>Auction Number</span></th>
                                                <th className="wd-lg-20p text-center"><span>Auction Date</span></th>
                                                <th className="wd-lg-20p text-center"><span>Status</span></th>
                                                <th className="wd-lg-20p text-center"><span>Start Time</span></th>
                                                <th className="wd-lg-20p text-center text-nowrap"><span>End Time</span></th>
                                                <th className="wd-lg-20p text-center ">Total Lots</th>
                                                <th className="wd-lg-20p text-center">Total Arrivals (Kg)</th>
                                                {/*<th className="wd-lg-20p text-center">User Fee (Rs)</th>*/}
                                                {/*<th className="wd-lg-40p text-center " style={{minWidth:100} }>CSR Amount (Rs)</th>*/}
                                                {/*<th className="wd-lg-20p">Action</th>*/}
                                                {/*<th className="wd-lg-20p">Lot Details</th>*/}
                                            </tr>
                                        </thead>
                                        <tbody className="custom-hover-table  text-nowrap">
                                            {auctions.map((auc, index) => {
                                                return <tr>
                                                    <td className="text-center"> {index + 1}
                                                        <div className="pos-absolute">
                                                            <div className="custom-button-container-left">
                                                                {auc.auctionStatus === 2 ? <div><span className="badge rounded-pill bg-dark mg-b-5">Auction closed</span></div> :
                                                                    auc.auctionStatus === 0 ? <div className="d-flex ">
                                                                        <button className="btn ripple btn-outline-primary btn-sm btn-rounded mg-r-5" onClick={() => editAuction(auc)}> <i className="fe fe-edit-2"></i> Edit</button>
                                                                        <button className="btn ripple btn-outline-danger btn-sm btn-rounded mg-r-5" onClick={() => deleteAuction(auc.auctionId)}>  <i className="fe fe-trash"> </i> Delete</button>
                                                                    </div> :
                                                                        <div className="d-flex "> 
                                                                            <button className="btn ripple btn-outline-danger btn-sm btn-rounded mg-r-5" onClick={() => closeAuction(auc.auctionId)}>  <i className="fe fe-stop"> </i> Close Auction</button>
                                                                            <button className="btn ripple btn-sm text-success btn-rounded " > <span class="spinner-grow spinner-grow-sm align-middle" role="status" aria-hidden="true"></span> Auction in progress..</button>
                                                                            
                                                                        </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="text-center"> {auc.auctionId} </td>
                                                    <td style={{ maxWidth: "600px", overflowX:"hidden" } }>
                                                        <a href="#" className="custom-link" onClick={(e) => viewLotDetails(e, auc)}> {auc.companyName.substring(0, 60)}...</a>
                                                    </td>
                                                    <td className="text-center"> {auc.auctionNo} </td>
                                                    <td className="text-center"><Moment format="DD-MMM-YYYY">{auc.auctionDate}</Moment>   </td>
                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-center">
                                                            {auc.auctionStatus === 0 ?
                                                                <span className="label text-muted d-flex align-items-center">
                                                                    <span className="dot-label bg-gray-300 me-1">
                                                                    </span>Awaiting</span> :
                                                                auc.auctionStatus === 1 ? <span className="label text-success d-flex align-items-center">
                                                                    <span className="dot-label bg-success me-1">
                                                                    </span>Running</span> :
                                                                    auc.auctionStatus === 2 ? <span className="label text-dark d-flex align-items-center">
                                                                        <span className="dot-label bg-dark me-1">
                                                                        </span>Closed</span> : null
                                                            }

                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        {auc.startTime ? <Moment format="LT">{auc.startTime}</Moment> : null}
                                                        {/*<div className="mg-t-4 text-nowrap show-on-hover">*/}
                                                        {/*    {auc.auctionStatus === 0 ?*/}
                                                        {/*        <button className="btn ripple btn-outline-info btn-sm btn-rounded mg-r-5" onClick={() => handleSessionModalVisibility(auc.auctionId, null, null)}>  Create Session </button> :*/}
                                                        {/*        <button className="btn ripple btn-outline-info btn-sm text-nowrap btn-sm btn-rounded mg-r-5" onClick={() => handleSessionModalVisibility(auc.auctionId, auc.startTime, auc.endTime)}>  Update Session </button>*/}
                                                        {/*    }*/}
                                                        {/*</div>*/}
                                                    </td>
                                                    <td className="text-center ">
                                                        {auc.endTime ? <Moment format="LT">{auc.endTime}</Moment> : null}
                                                        {/*{auc.auctionStatus === 1 ?*/}
                                                        {/*    <button className="btn ripple btn-outline-danger btn-sm text-nowrap btn-sm btn-rounded mg-r-5 show-on-hover" onClick={() => handleSessionModalVisibility(auc.auctionId, null, null)}>  Delete Session </button> : null*/}
                                                        {/*}*/}
                                                    </td>
                                                    <td className="text-center"> {auc.totalLots || "--"} </td>
                                                    <td className="text-center"> {auc.totalArrivals || "--"}
                                                        <div className="pos-absolute r-0">
                                                            <div className="custom-button-container-right">
                                                                <div className="d-flex ">
                                                                    {auc.auctionStatus === 0 && !auc.startTime ? <button className="btn ripple btn-outline-info btn-sm btn-rounded mg-r-5" onClick={() => createNewSession(auc.auctionId)}>  Create Session </button> : null}
                                                                    {auc.auctionStatus !== 2 && auc.startTime ? <button className="btn ripple btn-outline-info btn-sm text-nowrap btn-sm btn-rounded mg-r-5" onClick={() => updateSession(auc.auctionId, auc.startTime, auc.endTime)}>  Update Session </button> : null}
                                                                    {auc.auctionStatus === 0 && auc.startTime ? <button className="btn ripple btn-outline-danger btn-sm text-nowrap btn-sm btn-rounded mg-r-5 show-on-hover" onClick={() => deleteSession(auc.auctionId)}>  Delete Session </button> : null}
                                                                    <button className="btn ripple btn-outline-success btn-sm btn-rounded mg-r-5" onClick={() => handleLotGridView(auc.auctionId)}>  Bag View </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    {/*<td className="text-center"> {auc.userFee || "--"} </td>*/}
                                                    {/*<td className="text-center"> {auc.csrAmount || "--"} </td>*/}
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <Modal show={modalVisible} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add/Edit Auction</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            Auction Center (Primary auctioneer location)
                            <select name="stateId" className="form-control " onChange={handleCenterChange} value={auctionCenter} >
                                <option value="1">Puttady</option>
                                <option value="2">Bodinayakanur</option>
                            </select>
                        </div>
                        <div className="form-group">
                            Auctioneer
                            <select
                                className="form-control select2-show-search select2-dropdown select2-hidden-accessible"
                                tabIndex="-1"
                                aria-hidden="true"
                                value={auctioneerId}
                                onChange={handleAuctioneerChange}
                            >
                                <option label="Choose one"></option>
                                {auctioneers.map(t => {
                                    return <option value={t.auctioneerId}>{t.companyName}</option>
                                })}
                            </select>
                        </div>
                        <div className="form-group">
                            Auction Number
                            <input className="form-control" placeholder="Auction Number" type="number" value={auctionNo}
                                onChange={handleAuctionNoChange} />
                        </div>
                        <div className="form-group">
                            Auction Date <br></br>
                            <DatePicker className="form-control" dateFormat='dd-MMM-yyyy' selected={auctionDate}
                                onChange={handleDateChange} minDate={minDate} />
                        </div>


                        <div className="form-group">
                            Pooling State Date/Time

                            <DatePicker
                                className="form-control"
                                selected={poolingStartTime}
                                onChange={(time) => setPoolingStart(time)}
                                showTimeSelect
                                dateFormat="dd-MMM-yyyy h:mm aa"
                                timeCaption="[ Type or select ]"
                            />

                        </div>
                        <div className="form-group">
                            Pooling End Date/Time
                            <DatePicker
                                className="form-control"
                                selected={poolingEndTime}
                                onChange={(time) => setPoolingEnd(time)}
                                showTimeSelect
                                dateFormat="dd-MMM-yyyy h:mm aa"
                                timeCaption="[ Type or select ]"
                            />

                           
                        </div>


                        <div className="mg-t-6">
                            <button className="btn ripple btn-primary pd-x-30 mg-r-5" type="button" onClick={onSaveAuction}>
                                Save
                            </button>
                            <button className="btn ripple btn-light pd-x-30" onClick={handleClose}>
                                Close
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={modalSessionVisible} onHide={handleSessionModalVisibility}>
                    <Modal.Header closeButton>
                        <Modal.Title>Create/Update Trade Session</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            Start Time
                            <DatePicker
                                className="form-control"
                                selected={sessionStartTime}
                                filterTime={filterPassedTime}
                                onChange={(time) => setStartTime(time)}
                                disabled={isStartTimeDisabled}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                minTime={minTime} //set current time to disable past time
                                maxTime={maxTime}
                                // minTime={new Date().getTime()} //set current time to disable past time
                                dateFormat="h:mm aa"
                                timeCaption="[ Type or select ]"
                            />
                        </div>
                        <div className="form-group">
                            End Time
                            <DatePicker
                                className="form-control"
                                value
                                selected={sessionEndTime}
                                onChange={(time) => setEndTime(time)}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                filterTime={filterPassedTime}
                                minTime={minTime} //set current time to disable past time
                                maxTime={maxTime}
                                dateFormat="h:mm aa"
                                timeCaption="[ Type or select ]"
                            />
                        </div>

                        <div className="mg-t-6">
                            <button className="btn ripple btn-primary pd-x-30 mg-r-5" type="button" onClick={onSaveTradeSession}>
                                Save
                            </button>
                            <button className="btn ripple btn-light pd-x-30" onClick={handleSessionModalVisibility}>
                                Close
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
};

export default Auctions;



